export default __webpack_public_path__ + "static/media/buck_async_int_mosfet_ic_floating_gnd.49140b0f.svg";